/**
 * <hidden-header> — HIDDEN overlay header scroll behaviour.
 *
 * Toggles `data-scrolled` on itself: set as soon as the page is scrolled at all
 * (immediate, per gate decision 2026-07-28), removed when back at the very top so
 * the logo re-appears. The slide transition itself is pure CSS
 * (sections/hidden-header.liquid); this element only owns the state flag.
 */
class HiddenHeader extends HTMLElement {
  /** @type {(() => void) | null} */
  #onScroll = null;

  #ticking = false;

  connectedCallback() {
    this.#onScroll = () => {
      if (this.#ticking) return;
      this.#ticking = true;
      requestAnimationFrame(() => {
        this.#ticking = false;
        this.#update();
      });
    };
    window.addEventListener('scroll', this.#onScroll, { passive: true });
    this.#update();
  }

  disconnectedCallback() {
    if (this.#onScroll) window.removeEventListener('scroll', this.#onScroll);
    this.#onScroll = null;
  }

  #update() {
    if (window.scrollY > 0) {
      this.setAttribute('data-scrolled', '');
    } else {
      this.removeAttribute('data-scrolled');
    }
  }
}

if (!customElements.get('hidden-header')) {
  customElements.define('hidden-header', HiddenHeader);
}
